import axios from "axios";
import { API_URL } from "../config";

// Get auth headers with token
const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Extract error message from axios error
const extractErrorMessage = (error, defaultMessage = "Request failed") => {
  return (
    error.response?.data?.error?.message ||
    error.response?.data?.error ||
    error.message ||
    defaultMessage
  );
};

// Generic API request wrapper
const apiRequest = async (method, endpoint, data = null, options = {}) => {
  const config = {
    method,
    url: `${API_URL}${endpoint}`,
    headers: {
      ...getAuthHeaders(),
      ...options.headers,
    },
    ...options,
  };

  if (data) {
    config.data = data;
  }

  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    const errorMessage = extractErrorMessage(
      error,
      options.defaultErrorMessage,
    );
    throw new Error(errorMessage);
  }
};

// Convenience methods
export const apiService = {
  get: (endpoint, options = {}) => apiRequest("GET", endpoint, null, options),
  post: (endpoint, data, options = {}) =>
    apiRequest("POST", endpoint, data, options),
  put: (endpoint, data, options = {}) =>
    apiRequest("PUT", endpoint, data, options),
  patch: (endpoint, data, options = {}) =>
    apiRequest("PATCH", endpoint, data, options),
  delete: (endpoint, options = {}) =>
    apiRequest("DELETE", endpoint, null, options),

  // Helper for common error handling
  handleError: (error, setError, defaultMessage = "Request failed") => {
    const errorMessage = extractErrorMessage(error, defaultMessage);
    setError(errorMessage);
  },
};

export default apiService;
